export default __webpack_public_path__ + "static/media/41.fc6517df.jpeg";